import { LitElement, CSSResultGroup, unsafeCSS } from 'lit'
import style from '../../../node_modules/@picocss/pico/css/pico.min.css?inline';
import { customElement } from 'lit/decorators.js'


/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('parent-pico')
export class ParentPico extends LitElement {

    static styles: CSSResultGroup = [
        unsafeCSS(style)
    ]

}

declare global {
    interface HTMLElementTagNameMap {
        'parent-pico': ParentPico
    }
}